// Actions
export const EXPENSE_TYPE_FETCH  = '[ExpenseType] Fetch'

// Mutations
export const EXPENSE_TYPE_META   = '[ExpenseType] meta'
export const EXPENSE_TYPE_OBTAIN = '[ExpenseType] obtain'
export const EXPENSE_TYPE_CLEAR  = '[ExpenseType] clear'
export const EXPENSE_TYPE_SET_LOADING = '[ExpenseType] set loading'
